import { render, staticRenderFns } from "./chirp-conversation.vue?vue&type=template&id=68fef648&scoped=true&"
import script from "./chirp-conversation.vue?vue&type=script&lang=js&"
export * from "./chirp-conversation.vue?vue&type=script&lang=js&"
import style0 from "./chirp-conversation.vue?vue&type=style&index=0&id=68fef648&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fef648",
  null
  
)

export default component.exports